import React from "react";
import { Route, Switch } from "react-router-dom";
import AccountRouter from "../Account";
import ApplicationRouter from "../Appliction";
import { PATH_APP } from "../paths";
import { UnProtectedContent } from "../UnProtectedRouter/style";
import { JwtProvider } from "@/components/Auth/JwtProvider";
import Home from "@/views/Home";
import TopBar from "@/views/Layout/TopBar";
import { NotFound } from "@/views/NotFound";
import Organization from "@/views/Organization";
import useOrganizationInfoRequestThunk from "@/hooks/Organization/useOrganizationInfoRequestThunk";
import useGetUserInfoRequest from "@/hooks/user/useGetUserInfoRequest";

export default function ProtectedRouter() {
	useOrganizationInfoRequestThunk();
	useGetUserInfoRequest();

	return (
		<JwtProvider>
			<UnProtectedContent>
				<TopBar />
				<Switch>
					{/* <Route exact={true} path={PATH_APP.root} component={HomeMainView} /> */}
					<Route exact={true} path={PATH_APP.root} component={Home} />
					<Route path={PATH_APP.organization.root} component={Organization} />
					<Route
						path={PATH_APP.application.root}
						component={ApplicationRouter}
					/>
					<Route path={PATH_APP.account.root} component={AccountRouter} />
					<Route component={NotFound} />
					{/* <Route path="*" component={NotFound} /> */}
				</Switch>
			</UnProtectedContent>
		</JwtProvider>
	);
}
